import { STREAMED_QUERY_RETRY } from "@/lib/core/query-retry";

export type FindFeedRetryOptions = {
    retry: number;
    retryDelay: number;
    retryOnMount: boolean;
};

export const FIND_FEED_RETRY_OPTIONS: FindFeedRetryOptions = {
    ...STREAMED_QUERY_RETRY,
    retryOnMount: true,
};

export type FindLoadUi = "dogs" | "skeleton" | "empty" | "failure";

export type FindResultsSurface = FindLoadUi | "need-location";

export function resolveFindLoadUi(input: {
    hasDogs: boolean;
    isLoading: boolean;
    isFetching: boolean;
    isError: boolean;
    isFetchedAfterMount: boolean;
    isPlaceholderData: boolean;
}): FindLoadUi {
    if (input.isLoading || input.isFetching) {
        return input.hasDogs ? "dogs" : "skeleton";
    }
    if (input.isError) {
        if (input.hasDogs && input.isPlaceholderData === false) return "dogs";
        return input.isFetchedAfterMount ? "failure" : "skeleton";
    }
    if (input.hasDogs) return "dogs";
    return "empty";
}

export function resolveFindResultsSurface(input: {
    hasLocation: boolean;
    loadUi: FindLoadUi;
}): FindResultsSurface {
    if (!input.hasLocation) return "need-location";
    return input.loadUi;
}

export function shouldFinishFindFeedWordmarkOnPaint(input: {
    isResultsMode: boolean;
    feedLoadUi: FindLoadUi;
    findFeedIsFetching: boolean;
}): boolean {
    return (
        !input.isResultsMode &&
        input.feedLoadUi !== "skeleton" &&
        !input.findFeedIsFetching
    );
}
